import React, {Component} from 'react'
import PropTypes from 'prop-types'
import '../styles/index.scss'
import {Link} from 'react-router-dom'
import {Icon, Pagination} from 'antd'
import PartnerInfo from './PartnerInfo'
import BatchesFilters from './../../batchesV3/components/filters/BatchesFilters'
import BatchesTable from './../../batchesV3/components/table/BatchesTable'
import {getDetailPartner, getListItemPartner} from "../../../services/api/3dApi"

class PartnerPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            loadingPartner: false,
            errorPartner: '',
            batches: [],
            partner: {},
            filters: {
                name: '',
                partner: '',
                sewing_partner: '',
                level: '',
                overTimeIn: '',
                overTimeEp: '',
                product_types: [],
                user_create: '',
                status: '',
                batch_overtime: [],
                mex: '',
                sewed : 'all',
                delivered: '',
            },
            page: 1,
            limit: 100,
            total: 0
        }
    }

    componentDidMount() {
        this._fetchPartner()
    }

    _fetchPartner = async () => {
        this.setState({
            loadingPartner: true,
            errorPartner: ''
        })

        try {
            const {id} = this.props

            const {data: response} = await getDetailPartner(id)

            const {data, success, error} = response

            if (!success) {
                this.setState({
                    loadingPartner: false,
                    errorPartner: error
                })

                return
            }

            this.setState({
                loadingPartner: false,
                partner: data
            }, () => {
                this._fetchPartnerItems()
            })
        } catch (e) {
            this.setState({
                loadingPartner: false,
                errorPartner: e.message
            })
        }
    }

    _fetchPartnerItems = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {filters, limit, page} = this.state
            const {id} = this.props

            const payload = {
                ...filters,
                name: {'$in': filters.name},
                page: page,
                limit: limit
            }

            const {data: response} = await getListItemPartner(id, payload)

            const {data, success, error} = response

            if (!success) {
                this.setState({
                    loading: false,
                    error: error
                })

                return
            }

            this.setState({
                loading: false,
                batches: data.batches,
                total: data.total
            })


        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, this._fetchPartnerItems)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: current
        }, this._fetchPartnerItems)
    }

    _handleChangeInput = (field, value) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: value
                },
                page: 1
            }
        }, this._fetchPartnerItems)
    }

    _handleChangeProductType = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                product_types: value
            },
            page: 1
        }, this._fetchPartnerItems)
    }

    _handleChangeDate = (filters) => {
        this.setState({filters}, this._fetchPartnerItems)
    }

    _handleChangeStatus = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                status: value
            },
            page: 1
        }, this._fetchPartnerItems)
    }

    render() {
        const {errorPartner, loadingPartner, loading, error, partner, batches, filters, page, limit, total} = this.state
        const {id} = this.props

        return (
            <div className="PartnerPage">
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='TopHeading'>
                            <Link to={`/partners`}><Icon type="left"/> Danh sách đối tác</Link>
                        </div>
                        <div className='jumbotron col-12 mx-auto py-3 px-0 mb-3 bg-white'>
                            <PartnerInfo
                                id={id}
                                error={errorPartner}
                                loading={loadingPartner}
                                partner={partner}
                                onGetPartner={this._fetchPartner}
                            />
                        </div>

                        <div className='jumbotron col-12 mx-auto p-3 mb-3'>
                            <BatchesFilters
                                showPartner={false}
                                filters={filters}
                                loading={loading}
                                handleChangeInput={this._handleChangeInput}
                                handleChangeDate={this._handleChangeDate}
                                onChangeProductType={this._handleChangeProductType}
                            />
                        </div>

                        <div className="d-flex justify-content-between align-items-center headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                    </div>}
                                onChange={this._handlePageChange}
                                className='text-right mb-3' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={this._handleShowSizeChange}/>
                        </div>

                        <div className="BatchesTable">
                            <BatchesTable
                                batches={batches}
                                loading={loading}
                                onChangeProductType={this._handleChangeProductType}
                            />
                        </div>

                        <Pagination current={page} total={total} pageSize={limit}
                                    onChange={this._handlePageChange}
                                    showQuickJumper
                                    className='text-right' showSizeChanger
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onShowSizeChange={this._handleShowSizeChange}/>
                    </div>
                </div>
            </div>
        )
    }
}

PartnerPage.propTypes = {
    id: PropTypes.string.isRequired
}

export default PartnerPage
